import React, { ElementType } from 'react';

import { X } from 'lucide-react';

import { useModalContext } from './ModalContext';

interface ModalHeaderProps {
    children: React.ReactNode;
    className?: string;
    id?: string;
    as?: ElementType;
    href?: string;
    closeButtonClass?: string;
    showClose?: boolean;
}

const ModalHeader = ({
    children,
    className,
    closeButtonClass,
    showClose = true,
    as: Component = `div`,
    ...props
}: ModalHeaderProps) => {
    const { onHide, handleModalToggle } = useModalContext();

    return (
        <Component
            {...props}
            className={className ? className : `flex items-center   justify-between w-full`}
            onClick={onHide ? onHide : handleModalToggle}
        >
            {children}
            {showClose && (
                <button data-modal-close="closeModal" className={closeButtonClass ? closeButtonClass : ``}>
                    <X className="lucide lucide-x size-5"></X>
                </button>
            )}
        </Component>
    );
};

export default ModalHeader;
